import script from "./DocumentUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&setup=true&lang=js"

import "./DocumentUploader.vue?vue&type=style&index=0&id=f1000fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1000fb0"]])

export default __exports__